// Permanent floating phone CTA — sized to exactly match the "Made with
// Emergent" badge underneath it (178 × 40 px, fully rounded pill, black
// background). Stays in the bottom-right corner from page open to page close.
import { Phone } from "lucide-react";
import { useLang } from "../contexts/LangContext";

export default function MobileCallButton() {
  const { t } = useLang();
  const ct = t.mobile_call;

  return (
    <a
      // Pinned to the bottom-right with the maximum possible z-index so it
      // sits *on top of* the Emergent badge underneath.
      href="tel:+491758802646"
      style={{
        zIndex: 2147483647,
        width: 178,
        height: 40,
        borderRadius: 50,
        right: 16,
        bottom: 16,
      }}
      className="fixed bg-[#090A0B] text-white border border-[#FF5A00] shadow-2xl shadow-black/60 flex items-center justify-center gap-2 font-bold tracking-wider uppercase text-[11px] hover:bg-[#1A1B1F] transition-colors"
      data-testid="mobile-call-btn"
      aria-label="Jetzt anrufen +49 175 8802646"
      title="+49 175 8802646"
    >
      <span className="relative flex h-3.5 w-3.5 items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#FF5A00] opacity-50 animate-ping" />
        <Phone size={12} className="text-[#FF5A00] relative" />
      </span>
      <span>{ct.label}</span>
    </a>
  );
}
